import type { PropsWithChildren } from "react";
import { useRouter } from "next/router";
import { ROUTES } from "@nf/constants";
import { SourceType, UrlQuery, type CellType } from "@nf/common";

import LinkWithLocale from "components/LinkWithLocale";

export interface LinkToPlaylistProps {
  sourceId?: string | number;
  sourceType?: SourceType;
  cellType?: CellType;
  query?: UrlQuery;
}

export const LinkToPlaylist = ({
  sourceId,
  sourceType,
  cellType,
  children,
  query,
}: PropsWithChildren<LinkToPlaylistProps>) => {
  const router = useRouter();

  const pathname = `${
    sourceType === SourceType.Favourites
      ? ROUTES.MYLIST_SCREEN
      : ROUTES.PLAYLIST_SCREEN
  }/${sourceId}/${cellType?.toLowerCase()}/${router.query.id}`;

  return (
    <LinkWithLocale
      href={{
        pathname,
        query,
      }}
    >
      {children}
    </LinkWithLocale>
  );
};
